/* global I18n */

import React from "react"
import KenhubModal from "../kenhub_modal"
import DetailedLearnableProgressBox from "./detailed_learnable_progress_box"
import LearningLevelKeys from "./learning_level_keys"
import ProgressBadge from "./progress_badge"

function StudySummaryModal({
  on_close,
  is_open,
  learnables,
  average_knowledge_change
}) {

  return (
    <KenhubModal
      class_name="modal-wide study-summary"
      label={I18n.t("js.new_embedded_quiz.study_summary.detailed_progress")}
      on_close={on_close}
      is_open={is_open}>
      <div className="modal-header">
        <h3 className="modal-title">
          {I18n.t("js.new_embedded_quiz.study_summary.detailed_progress")}
          <button className="btn btn-link close" onClick={on_close}></button>
        </h3>
        <div className="info-line">
          <div className="overall-change">
            <ProgressBadge change={average_knowledge_change}/>
            {I18n.t("js.new_embedded_quiz.study_summary.knowledge_change")}
          </div>
          <LearningLevelKeys/>
        </div>
      </div>
      <div className="modal-body">
        <div className="detailed-learning-progress-list">
          {learnables.map((learnable) => (
            <DetailedLearnableProgressBox
              key={learnable.slug}
              learnable={learnable}/>
          ))}
        </div>
      </div>
    </KenhubModal>
  )
}

export default StudySummaryModal
